import { render } from "./eproc-baca.vue?vue&type=template&id=66a700a1&scoped=true"
import script from "./eproc-baca.vue?vue&type=script&lang=js"
export * from "./eproc-baca.vue?vue&type=script&lang=js"

import "./eproc-baca.vue?vue&type=style&index=0&id=66a700a1&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a700a1"]])

export default __exports__